import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { FiCpu, FiHardDrive, FiMonitor, FiServer, FiWifi } from 'react-icons/fi';

import ScorePropTypes from '../../proptypes/score';
import ArrayScoreConsumption from './ArrayScoreConsumption';
import MetricCard from './MetricCard';

const ScoreMetrics = ({
    score,
    scoreReference,
    precision,
    displayTotal,
    executionCount,
}) => {
    return (
        <>
            {displayTotal && (
                <Box display="flex">
                    <ArrayScoreConsumption
                        score={score}
                        executionCount={executionCount ?? 1000}
                    />
                </Box>
            )}
            <Box
                display="flex"
                flexDirection={{ xs: 'column', md: 'row' }}
                flexWrap="wrap"
                alignItems="stretch"
                width="100%"
                gap={2}
            >
                <MetricCard
                    name="CPU"
                    icon={<FiCpu />}
                    value={score.s?.cpu}
                    unit="s"
                    score={score.wh.cpu}
                    total={score.wh.total}
                    scoreReference={scoreReference?.wh?.cpu}
                />
                <MetricCard
                    name="Network"
                    icon={<FiWifi />}
                    value={score.gb?.network * 1000}
                    unit="MB"
                    score={score.wh.network}
                    total={score.wh.total}
                    scoreReference={scoreReference?.wh?.network}
                />
                {!!score.wh.screen && (
                    <MetricCard
                        name="Screen"
                        icon={<FiMonitor />}
                        value={score.s?.screen}
                        unit="s"
                        score={score.wh.screen}
                        total={score.wh.total}
                        scoreReference={scoreReference?.wh?.screen}
                    />
                )}
                <MetricCard
                    name="Memory"
                    icon={<FiServer />}
                    value={score.gb?.mem}
                    unit="GB"
                    score={score.wh.mem}
                    total={score.wh.total}
                    scoreReference={scoreReference?.wh?.mem}
                />
                <MetricCard
                    name="Disk"
                    icon={<FiHardDrive />}
                    value={score.gb?.disk}
                    unit="GB"
                    score={score.wh.disk}
                    total={score.wh.total}
                    scoreReference={scoreReference?.wh?.disk}
                />
            </Box>
        </>
    );
};

ScoreMetrics.propTypes = {
    score: ScorePropTypes,
    precision: PropTypes.number,
    scoreReference: ScorePropTypes,
    displayTotal: PropTypes.bool,
    executionCount: PropTypes.number,
};

export default ScoreMetrics;
